import React, { useContext, useEffect, useState } from "react";
import Infocards from "../Cards/Infocards";
import { FilterContext } from "../../context/Filter";
import { fetchcustomerrelationshipage, fetchdealertheybuyfrom, fetchvehicle, fetchcitycount, fetchcitylist, fetchtotalfleetid, fetchgetDealerList } from "../../components/ChildData/Infocardskpi"
import { use } from "react";

const Infocarddata = () => {

    const { datat, setDatat } = useContext(FilterContext);
    const { dealers, setDealers } = useContext(FilterContext);
    const { city, setCity } = useContext(FilterContext);
    const { citylist, setCitylist } = useContext(FilterContext);
    const { age, setAge } = useContext(FilterContext);
    const { dealerslist, setDealerslist } = useContext(FilterContext);
    const { fleetid, setFleetid } = useContext(FilterContext);

    const { superArn: parArn, childArn } = useContext(FilterContext);

    // console.log(childArn, "childarn")

    const key = childArn ? "childArn" : "parArn";
    const value = childArn || parArn;
    const payload = { [key]: value };


    const fetchtotalvehicledata = async () => {

        try {
            const result = await fetchvehicle(payload);
            setDatat(result?.doc_count);
        } catch (error) {
            console.error("Error fetching vehicle data:", error);
        }
    };


    const fetchtotalfleetids = async () => {
        try {
            const result = await fetchtotalfleetid(payload);
            // console.log("totalfleet", result);
            setFleetid(result.value);
        } catch (error) {
            console.error("Error fetching vehicle data:", error);
        }
    };


    const fetchcityList = async () => {
        try {
            const result = await fetchcitylist(payload);

            setCitylist(result);
        } catch (error) {
            console.error("Error fetching vehicle data:", error);
        }
    };
    //console.log("city", citylist)



    const fetchcitycount1 = async () => {
        try {
            const result = await fetchcitycount(payload);
            setCity(result.value);

        } catch (error) {
            console.error("Error fetching vehicle data:", error);
        }
    };


    const fetchdealers = async () => {
        try {
            const result = await fetchdealertheybuyfrom(payload);
            setDealers(result?.unique_dealer_count?.value);
        } catch (error) {
            console.error("Error fetching vehicle data:", error);
        }
    }



    const fetchcustomerrltn = async () => {
        try {
            const result = await fetchcustomerrelationshipage(payload);
            setAge(result?.fields?.years_months_since_first_sale[0]);

        } catch (error) {
            console.error("Error fetching vehicle data:", error);
        }
    };
    //console.log("age", age)


    const fetchgetDealerListt = async () => {
        try {
            const result = await fetchgetDealerList(payload);
            setDealerslist(result);
        } catch (error) {
            console.error("Error fetching vehicle data:", error);
        }
    };
    //console.log("dealerslist:", dealerslist);

    useEffect(() => {

        fetchtotalfleetids();
        fetchcitycount1();
        fetchcityList();
        fetchdealers();
        fetchgetDealerListt();
        fetchcustomerrltn();
        fetchtotalvehicledata();

    }, [parArn, childArn]);

    return (

        <div>

        </div>

    );
};

export default Infocarddata;
